export default "__VITE_ASSET__Bx1JO2PP__"